var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"box"},[_c('img',{attrs:{"src":require("../../assets/assess/success.png"),"alt":""}}),(_vm.type==='linen')?_c('div',[_vm._v("布草申领单已提交完成!")]):_c('div',[_vm._v("物品申领单已提交完成!")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }